export default __webpack_public_path__ + "static/media/bannerSmall6.4e93f299.png";